import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

export interface TimeSeriesPoint {
  date: string; // ISO YYYY-MM-DD
  valueCents: number;
}

interface Props {
  data: TimeSeriesPoint[];
  height?: number;
  goalCents?: number;
  formatter?: (cents: number) => string;
}

const defaultFormatter = (cents: number) =>
  new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
  }).format(cents / 100);

export function TimeSeriesLineChart({
  data,
  height = 240,
  goalCents,
  formatter = defaultFormatter,
}: Props) {
  if (data.length === 0) return null;

  const sorted = [...data].sort((a, b) => a.date.localeCompare(b.date));

  return (
    <div style={{ width: "100%", height }}>
      <ResponsiveContainer>
        <LineChart data={sorted} margin={{ top: 8, right: 16, left: 0, bottom: 8 }}>
          <CartesianGrid stroke="#e5e7eb" strokeDasharray="3 3" />
          <XAxis dataKey="date" tick={{ fontSize: 12 }} />
          <YAxis tickFormatter={(v) => formatter(Number(v))} tick={{ fontSize: 12 }} width={80} />
          <Tooltip formatter={(v: number) => formatter(v)} labelFormatter={(l: string) => l} />
          <Line
            type="monotone"
            dataKey="valueCents"
            stroke="#2563eb"
            strokeWidth={2}
            dot={{ r: 3 }}
          />
          {goalCents !== undefined && (
            <Line
              type="monotone"
              data={sorted.map((p) => ({ ...p, valueCents: goalCents }))}
              dataKey="valueCents"
              stroke="#10b981"
              strokeDasharray="4 4"
              dot={false}
            />
          )}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
